// everything websocket related

(function ($) {
  var that = {};

  that.socket = false;

  that.getConnectOptions = function() {
    return {
      reconnectionDelay: 10000,
      reconnectionDelayMax: 60000,
      transports: ['websocket']
    };
  };

  that.getConnectHost = function(options) {
    if(typeof options === "undefined" ) {
      options = {
        host: window.location.host
      };
    }
    var ret = options.host;
    if(typeof options.port !== "undefined" && options.port) {
      ret +=  ":" + options.port;
    }
    return ret;
  };

  that.getGlobalBlogId = function() {
    return sage_js.blog_id;
  };

  // use this function if not in session
  // TODO: unify
  that.getGlobalSessionId = function() {
    return sessionId;
  };
  // use this function in session
  that.getGlobalSessionIdSession = function() {
    return ajax_variables.post_id;
  };

  that.initAlways = function() {
    // if some error happens during login or cookie check
    /*
    that.socket.on('redirect-to-login', function (msg) {
      // wait 3 sec for user to read message popup
      setTimeout(function(){
        window.location.href = getLibObject("config").loginRedirect;
      },3000);
    });
    */
    that.socket.on('redirect-to-front', function (msg) {
        window.location.href = '/';
    });
  };

  that.getGlobalPostId = function () {
    return sage_js.post_id;
  };

  that.initModComments = function (options) {
    var libComments = getLibObject("comments");
    var libStageDirections = getLibObject("stagedirections");
    var libHelper = getLibObject("helper");

    try {
      var context = "comment_dashboard";
      var blogId = that.getGlobalBlogId();
      var sessionId = that.getGlobalSessionId();

      // session id is set in page template
      if(!sessionId) {
        throw new Error("missing sessionId");
      }

      var query = "?blogId=" + blogId + "&context=" + context + "&sessionId=" + sessionId;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );

      that.initAlways();

      that.socket.on('init-settings', function (msg) {
        libHelper.log("init-settings");
        libHelper.log(msg);
      });

      that.socket.on('modpage-field-changed', function (msg) {
        libHelper.log("session-field changed - reloading now");
        libHelper.reloadPage();
      });

      var eventNameCommentVoteNew = 'commentvote-new';
      that.socket.on(eventNameCommentVoteNew, function (msg) {
        libHelper.log("incoming " + eventNameCommentVoteNew);
        libHelper.log(msg);

        if(msg.data.comment) {
          var karma = parseInt(msg.data.votesTotal);
          var commentId = parseInt(msg.data.comment.comment_ID);
          libComments.modCommentUpdateState(commentId, 'comment_karma', karma);
          libComments.modCommentUpdateDom(commentId, 'comment_karma', karma);
          libComments.modCommentUpdateDashboard(commentId);
        }
      });

      var eventNameCommentChosenActivate = 'commentchosen-activate';
      that.socket.on(eventNameCommentChosenActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentChosenActivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_chosen', true);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
        }
      });
      var eventNameCommentChosenDeactivate = 'commentchosen-deactivate';
      that.socket.on(eventNameCommentChosenDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentChosenDeactivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_chosen', false);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_chosen', false);
          libComments.modCommentUpdateDashboard(msg.data.commentId);
        }
      });

      var eventNameCommentHotActivate = 'commenthot-activate';
      that.socket.on(eventNameCommentHotActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHotActivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_hot', true);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
        }
      });
      var eventNameCommentHotDeactivate = 'commenthot-deactivate';
      that.socket.on(eventNameCommentHotDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHotDeactivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_hot', false);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_hot', false);
          libComments.modCommentUpdateDashboard(msg.data.commentId);
        }
      });

      var eventNameCommentRemovedActivate = 'commentremoved-activate';
      that.socket.on(eventNameCommentRemovedActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentRemovedActivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_removed', true);
          libComments.modCommentRemoveFromDashboard(msg.data.commentId);
        }
      });
      var eventNameCommentRemovedDeactivate = 'commentremoved-deactivate';
      that.socket.on(eventNameCommentRemovedDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentRemovedDeactivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_removed', false);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
        }
      });

      /*
      var eventNameCommentMarkedActivate = 'commentmarked-activate';
      that.socket.on(eventNameCommentMarkedActivate, function (msg) {
          libHelper.log("incoming " + eventNameCommentMarkedActivate);
          libHelper.log(msg);

          // no action here
      });
      var eventNameCommentMarkedDeactivate = 'commentmarked-deactivate';
      that.socket.on(eventNameCommentMarkedDeactivate, function (msg) {
          libHelper.log("incoming " + eventNameCommentMarkedDeactivate);
          libHelper.log(msg);

          // no action here
      });
      */

      var eventNameCommentHighlightActivate = 'commenthighlight-activate';
      that.socket.on(eventNameCommentHighlightActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightActivate);
        libHelper.log(msg);

        // state-is-highlight
        libComments.modCommentUpdateState(msg.data.commentId, 'comment_highlight', true);
        $('#comment-' + msg.data.commentId).addClass('state-is-highlight');
      });
      var eventNameCommentHighlightDeactivate = 'commenthighlight-deactivate';
      that.socket.on(eventNameCommentHighlightDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightDeactivate);
        libHelper.log(msg);

        // just change highlight status of button
        libComments.modCommentUpdateState(msg.data.commentId, 'comment_highlight', false);
        $('#comment-' + msg.data.commentId).removeClass('state-is-highlight');
      });

      var eventNameCommentStageDirectionChange = 'commentstagedirection-change';
      that.socket.on(eventNameCommentStageDirectionChange, function (msg) {
        libHelper.log("incoming " + eventNameCommentStageDirectionChange);
        libHelper.log(msg);

        // update stage direction text
        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_stage_direction', msg.data.stageDirection);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_stage_direction', msg.data.stageDirection);
        }
      });

      // STAGEDIRECTION CPT EVENTS
      var eventNameStageDirectionChosenActivate = 'directionchosen-activate';
      that.socket.on(eventNameStageDirectionChosenActivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionChosenActivate);
        libHelper.log(msg);

        if(msg.data.post) {
          libStageDirections.modStageDirectionUpdateStateFull(msg.data.post);
          libStageDirections.modStageDirectionUpdateDom(msg.data.post.ID, 'direction_chosen', true);
          libStageDirections.modStageDirectionUpdateDashboard(msg.data.post.ID);
        }
      });
      var eventNameStageDirectionChosenDeactivate = 'directionchosen-deactivate';
      that.socket.on(eventNameStageDirectionChosenDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionChosenDeactivate);
        libHelper.log(msg);

        if(msg.data.postId) {
          libStageDirections.modStageDirectionUpdateState(msg.data.postId, 'direction_chosen', false);
          libStageDirections.modStageDirectionUpdateDom(msg.data.postId, 'direction_chosen', false);
          libStageDirections.modStageDirectionUpdateDashboard(msg.data.postId);
        }
      });

      var eventNameStageDirectionHotActivate = 'directionhot-activate';
      that.socket.on(eventNameStageDirectionHotActivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionHotActivate);
        libHelper.log(msg);

        if(msg.data.post) {
          libStageDirections.modStageDirectionUpdateStateFull(msg.data.post);
          libStageDirections.modStageDirectionUpdateDom(msg.data.post.ID, 'direction_hot', true);
          libStageDirections.modStageDirectionUpdateDashboard(msg.data.post.ID);
        }
      });
      var eventNameStageDirectionHotDeactivate = 'directionhot-deactivate';
      that.socket.on(eventNameStageDirectionHotDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionHotDeactivate);
        libHelper.log(msg);

        if(msg.data.postId) {
          libStageDirections.modStageDirectionUpdateState(msg.data.postId, 'direction_hot', false);
          libStageDirections.modStageDirectionUpdateDom(msg.data.postId, 'direction_hot', false);
          libStageDirections.modStageDirectionUpdateDashboard(msg.data.postId);
        }
      });

      var eventNameStageDirectionRemovedActivate = 'directionremoved-activate';
      that.socket.on(eventNameStageDirectionRemovedActivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionRemovedActivate);
        libHelper.log(msg);

        if(msg.data.postId) {
          libStageDirections.modStageDirectionUpdateState(msg.data.postId, 'direction_removed', true);
          libStageDirections.modStageDirectionRemoveFromDashboard(msg.data.postId);
        }
      });
      var eventNameStageDirectionRemovedDeactivate = 'directionremoved-deactivate';
      that.socket.on(eventNameStageDirectionRemovedDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameStageDirectionRemovedDeactivate);
        libHelper.log(msg);

        if(msg.data.post) {
          libStageDirections.modStageDirectionUpdateStateFull(msg.data.post);
          libStageDirections.modStageDirectionUpdateDom(msg.data.post.ID, 'direction_removed', false);
          libStageDirections.modStageDirectionUpdateDashboard(msg.data.post.ID);
        }
      });

      that.socket.on('comment-edit', function (msg) {
        getLibObject("helper").log("comment-edit");
        getLibObject("helper").log(msg);

        libComments.modCommentUpdateDom(msg.data.comment_ID, 'comment_content', getLibObject('comments').replaceSmileys(msg.data.comment_content));
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      libHelper.log("init websocket error:");
      libHelper.log(e);
    }
    return false;
  };

  that.initUserBubbleScreenPartially = function (options) {
    var libComments = getLibObject("comments");
    var libHelper = getLibObject("helper");

    try {
      var context = "user_bubble_screen";
      var blogId = that.getGlobalBlogId();
      var sessionId = that.getGlobalSessionId();

      // session id is set in page template
      if(!sessionId) {
        throw new Error("missing sessionId");
      }

      var query = "?blogId=" + blogId + "&context=" + context + "&sessionId=" + sessionId;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );

      that.initAlways();

      that.socket.on('init-settings', function (msg) {
        libHelper.log("init-settings");
        libHelper.log(msg);
      });

      var eventNameCommentHighlightActivate = 'commenthighlight-activate';
      that.socket.on(eventNameCommentHighlightActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightActivate);
        libHelper.log(msg);

        // set class and open popup
        var container = $(".bubble-container");
        var commentEl = container.find(".bubble[data-comment-id='" + msg.data.commentId + "']");
        commentEl.addClass('state-is-highlight').trigger("click");
      });
      var eventNameCommentHighlightDeactivate = 'commenthighlight-deactivate';
      that.socket.on(eventNameCommentHighlightDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightDeactivate);
        libHelper.log(msg);

        var container = $(".bubble-container");
        var commentEl = container.find(".bubble[data-comment-id='" + msg.data.commentId + "']");
        commentEl.removeClass('state-is-highlight');
        $.fancybox.close(true);
      });

      that.socket.on('comment-edit', function (msg) {
        getLibObject("helper").log("comment-edit");
        getLibObject("helper").log(msg);

        // add to comment list
        if(msg.data.comment_ID) {
          libComments.bubbleCommentUpdateDom(msg.data.comment_ID, 'comment_content', getLibObject('comments').replaceSmileys(msg.data.comment_content));
        }
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      libHelper.log("init websocket error:");
      libHelper.log(e);
    }
    return false;
  };

  that.initUserBubbleScreen = function (options) {
    var libComments = getLibObject("comments");
    var libHelper = getLibObject("helper");
    var libUser = getLibObject("user");

    try {
      var context = "user_bubble_screen";
      var blogId = that.getGlobalBlogId();
      var sessionId = that.getGlobalSessionId();
      var bubbleContainer = $(".bubble-container");

      // session id is set in page template
      if(!sessionId) {
        throw new Error("missing sessionId");
      }

      var query = "?blogId=" + blogId + "&context=" + context + "&sessionId=" + sessionId;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );

      that.initAlways();

      that.socket.on('init-settings', function (msg) {
        libHelper.log("init-settings");
        libHelper.log(msg);
      });

      that.socket.on('commentpage-field-changed', function (msg) {
        libHelper.log("session-field changed - reloading now");
        libHelper.reloadPage();
      });

      var eventNameCommentVoteNew = 'commentvote-new';
      that.socket.on(eventNameCommentVoteNew, function (msg) {
        libHelper.log("incoming " + eventNameCommentVoteNew);
        libHelper.log(msg);

        if(msg.data.comment) {
          var karma = parseInt(msg.data.votesTotal);
          var commentId = parseInt(msg.data.comment.comment_ID);
          libComments.modCommentUpdateState(commentId, 'comment_karma', karma);
          libComments.modCommentUpdateDom(commentId, 'comment_karma', karma);
          libComments.modCommentUpdateDashboard(commentId);
          libUser.bubbleCommentUpdateDom(msg.data.comment);
        }
      });

      var eventNameCommentChosenActivate = 'commentchosen-activate';
      that.socket.on(eventNameCommentChosenActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentChosenActivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_chosen', true);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
          libUser.insertOrUpdateCommentBubble(msg.data.comment, getLibObject('config').ajax_templates.zuschauerComment, bubbleContainer);
        }
      });
      var eventNameCommentChosenDeactivate = 'commentchosen-deactivate';
      that.socket.on(eventNameCommentChosenDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentChosenDeactivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_chosen', false);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_chosen', false);
          libComments.modCommentUpdateDashboard(msg.data.commentId);
          libUser.deleteCommentBubble(bubbleContainer, msg.data.comment);
        }
      });

      var eventNameCommentHotActivate = 'commenthot-activate';
      that.socket.on(eventNameCommentHotActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHotActivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_hot', true);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
          libUser.insertOrUpdateCommentBubble(msg.data.comment, getLibObject('config').ajax_templates.zuschauerComment, bubbleContainer);
        }
      });
      var eventNameCommentHotDeactivate = 'commenthot-deactivate';
      that.socket.on(eventNameCommentHotDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHotDeactivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_hot', false);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_hot', false);
          libComments.modCommentUpdateDashboard(msg.data.commentId);
          libUser.deleteCommentBubble(bubbleContainer, msg.data.comment);
        }
      });

      var eventNameCommentRemovedActivate = 'commentremoved-activate';
      that.socket.on(eventNameCommentRemovedActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentRemovedActivate);
        libHelper.log(msg);

        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_removed', true);
          libComments.modCommentRemoveFromDashboard(msg.data.commentId);
          libUser.deleteCommentBubble(bubbleContainer, msg.data.comment);
        }
      });
      var eventNameCommentRemovedDeactivate = 'commentremoved-deactivate';
      that.socket.on(eventNameCommentRemovedDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentRemovedDeactivate);
        libHelper.log(msg);

        if(msg.data.comment) {
          libComments.modCommentUpdateStateFull(msg.data.comment);
          libComments.modCommentUpdateDom(msg.data.comment.comment_ID, 'comment_removed', false);
          libComments.modCommentUpdateDashboard(msg.data.comment.comment_ID);
          libUser.insertOrUpdateCommentBubble(msg.data.comment, getLibObject('config').ajax_templates.zuschauerComment, bubbleContainer);
        }
      });

      /*
      var eventNameCommentMarkedActivate = 'commentmarked-activate';
      that.socket.on(eventNameCommentMarkedActivate, function (msg) {
          libHelper.log("incoming " + eventNameCommentMarkedActivate);
          libHelper.log(msg);

          // no action here
      });
      var eventNameCommentMarkedDeactivate = 'commentmarked-deactivate';
      that.socket.on(eventNameCommentMarkedDeactivate, function (msg) {
          libHelper.log("incoming " + eventNameCommentMarkedDeactivate);
          libHelper.log(msg);

          // no action here
      });
      */

      var eventNameCommentHighlightActivate = 'commenthighlight-activate';
      that.socket.on(eventNameCommentHighlightActivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightActivate);
        libHelper.log(msg);

        // set class and open popup
        var commentEl = bubbleContainer.find(".bubble[data-comment-id='" + msg.data.commentId + "']");
        commentEl.addClass('state-is-highlight').trigger("click");
      });
      var eventNameCommentHighlightDeactivate = 'commenthighlight-deactivate';
      that.socket.on(eventNameCommentHighlightDeactivate, function (msg) {
        libHelper.log("incoming " + eventNameCommentHighlightDeactivate);
        libHelper.log(msg);

        var commentEl = bubbleContainer.find(".bubble[data-comment-id='" + msg.data.commentId + "']");
        commentEl.removeClass('state-is-highlight');
        $('.fancybox-overlay').click();
      });


      var eventNameCommentStageDirectionChange = 'commentstagedirection-change';
      that.socket.on(eventNameCommentStageDirectionChange, function (msg) {
        libHelper.log("incoming " + eventNameCommentStageDirectionChange);
        libHelper.log(msg);

        // update stage direction text
        if(msg.data.commentId) {
          libComments.modCommentUpdateState(msg.data.commentId, 'comment_stage_direction', msg.data.stageDirection);
          libComments.modCommentUpdateDom(msg.data.commentId, 'comment_stage_direction', msg.data.stageDirection);
        }
      });

      that.socket.on('comment-edit', function (msg) {
        getLibObject("helper").log("comment-edit");
        getLibObject("helper").log(msg);

        // add to comment list
        if(msg.data.comment_ID) {
          libComments.bubbleCommentUpdateDom(msg.data);
        }
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      libHelper.log("init websocket error:");
      libHelper.log(e);
    }
    return false;
  };

  /**
   *
   * @param options
   * @returns {boolean}
   */
  that.initSession = function (options) {
    var libComments = getLibObject("comments");
    var libHelper = getLibObject("helper");
    var libUser = getLibObject("user");

    try {
      getLibObject("helper").log("init websocket");

      //var isSession = true; // Todo: find out if is session
      //if(isSession) {
      // }

      var context = "session";
      var blogId = that.getGlobalBlogId();
      var sessionId = that.getGlobalSessionIdSession();

      var player = getLibObject("player");
      var poll = getLibObject("poll");
      var query = "?blogId=" + blogId + "&context=" + context + "&sessionId=" + sessionId;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );

      that.initAlways();

      that.socket.on('init-session', function (msg) {
        getLibObject("helper").log("init-session");
        getLibObject("helper").log(msg);

        // todo: handle init
        // still not sure if I should send one big object at start or only single events
        //getLibObject("countdown").activateQuestionBox();
      });

      that.socket.on('init-bbb', function (msg) {
        player.session.initBbb(msg.data.bbbMeetings);
      });

      that.socket.on('session-field-changed', function (msg) {
        if(msg.data.fieldName === "anzeige") {
          player.session.fieldChangedShow(msg.data.value);
        } else if(msg.data.fieldName === "startzeit") {
          player.session.fieldChangedStartTime(msg.data.value);
        } else if(msg.data.fieldName === "startzeit_front") {
          player.session.fieldChangedStartTimeFront(msg.data.value);
        } else if(msg.data.fieldName === "endzeit") {
          player.session.fieldChangedEndTime(msg.data.value);
        } else if(msg.data.fieldName === "pre-event-url") {
          player.session.fieldChangedPreEventUrl(msg.data.value);
        } else if(msg.data.fieldName === "event-url") {
          player.session.fieldChangedEventUrl(msg.data.value);
        } else if(msg.data.fieldName === "post-event-url") {
          player.session.fieldChangedPostEventUrl(msg.data.value);
        } else if(msg.data.fieldName === "pre-poster") {
          player.session.fieldChangedPrePoster(msg.data.value);
        } else if(msg.data.fieldName === "post-poster") {
          player.session.fieldChangedPostPoster(msg.data.value);
        } else if(msg.data.fieldName === "menti-url") {
          poll.fieldChangedMentimeterUrl(msg.data.value);
        } else if(msg.data.fieldName === "menti-active") {
          poll.fieldChangedMentimeterActive(msg.data.value);
        } else if(msg.data.fieldName === "comment_infotext") {
          libComments.fieldChangedInfotext(msg.data.value);
        } else if(msg.data.fieldName === "comment_infotext_activate") {
          libComments.fieldChangedInfotextActivate(msg.data.value);
        } else if(msg.data.fieldName === "chatbutton_link") {
          libComments.fieldChangedChatbutton(msg.data.value);
        } else if(msg.data.fieldName === "feedback_popup_aktivieren") {
          player.fieldChangedFeedbackFormShow(msg.data.value);
        } else if(msg.data.fieldName === "link_zu_feedbackformular") {
          player.fieldChangedFeedbackFormUrl(msg.data.value);
        } else if(msg.data.fieldName === "bbb_show") {
          player.session.fieldChangedBbbShow(msg.data.value);
        } else if(msg.data.fieldName === "comments_top_count") {
          libComments.commentsTopCount = msg.data.value;
          libComments.updateTop5FromComments();
        } else if(msg.data.fieldName === "redirect-url") {
          player.fieldChangedRedirectUrl(msg.data.value);
        }
      });

      that.socket.on('session-commentstatus-changed', function (msg) {
        getLibObject("helper").log("session-commentstatus-changed");

        if(msg.data.commentStatus === "open") {
          getLibObject("countdown").activateQuestionBox();
          libComments.enableCommentTab();
        } else {
          getLibObject("countdown").deactivateQuestionBox();
          libComments.disableCommentTab();
        }
      });

      that.socket.on('comment-new', function (msg) {
        getLibObject("helper").log("comment-new");
        getLibObject("helper").log(msg);

        // add to comment list
        libComments.insertCommentFromWebsocket(msg.data);
      });

      that.socket.on('comment-untrash', function (msg) {
        getLibObject("helper").log("comment-untrash");
        getLibObject("helper").log(msg);

        // add to comment list
        // libComments.unTrashCommentFromWebsocket(msg.data.commentId);
      });

      that.socket.on('comment-delete', function (msg) {
        getLibObject("helper").log("comment-delete");
        getLibObject("helper").log(msg);

        // add to comment list
        libComments.deleteCommentFromWebsocket(msg.data.commentId);
      });

      that.socket.on('comment-edit', function (msg) {
        getLibObject("helper").log("comment-edit");
        getLibObject("helper").log(msg);

        // add to comment list
        libComments.updateCommentFromWebsocket(msg.data);
      });

      that.socket.on('pollvote-new', function (msg) {
        getLibObject("helper").log("pollvote-new");
        getLibObject("helper").log(msg);

        // do nothing for user
        // todo
      });

      that.socket.on('commentvote-new', function (msg) {
        getLibObject("helper").log("commentvote-new");
        getLibObject("helper").log(msg);

        // update comment votes
        libComments.updateVoteFromWebsocket(msg.data.comment, msg.data.votesTotal);
      });

      that.socket.on('poll-activate', function (msg) {
        getLibObject("helper").log("poll-activate");
        getLibObject("helper").log(msg);

        // update comment votes
        getLibObject("poll").activatePollFromWebsocket(msg.data, msg.answers);
      });

      that.socket.on('poll-deactivate', function (msg) {
        getLibObject("helper").log("poll-deactivate");
        getLibObject("helper").log(msg);

        // update comment votes
        getLibObject("poll").deactivatePollFromWebsocket(msg.data, msg.answers);
      });

      that.socket.on('poll-disable', function (msg) {
        getLibObject("helper").log("poll-disable");
        getLibObject("helper").log(msg);

        // update comment votes
        getLibObject("poll").disablePollFromWebsocket(msg.data);
      });

      that.socket.on('init-comments', function(msg){
        getLibObject("helper").log("init-comments");
        getLibObject("helper").log(msg);

        getLibObject("comments").initSessionComments(msg.data.comments);
      });

      that.socket.on('new-user-activity', function(msg){
        getLibObject("helper").log("user-activity-thementag");
        getLibObject("helper").log(msg);

        libUser.insertThementagUserBubble(msg);
      });

      that.socket.on('init-save-session', function (msg) {
        getLibObject("helper").log("init-save-session");
        getLibObject("helper").log(msg);

        getLibObject("savethedate").initSaveASession(msg.data);
      });

      that.socket.on('disable-chat-input', function () {
        console.log('halloo');
        getLibObject("helper").log("disable-chat-input");

        getLibObject("comments").disableChatInput();
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      getLibObject("helper").log("init websocket error:");
      getLibObject("helper").log(e);
    }
    return false;
  };

  that.initPoll = function (options) {
    var libPoll = getLibObject("poll");
    var libHelper = getLibObject("helper");

    try {
      getLibObject("helper").log("init websocket");

      // if no session is selected template will change to selected poll from poll options
      // if session is selected page will stick to
      var context = "poll_result";
      var blogId = that.getGlobalBlogId();
      var postId = that.getGlobalPostId();
      var selectedPoll = $("#poll-results").attr("data-selected-poll");
      var useGlobalPollSelection = true;
      if(selectedPoll !== "0") {
        useGlobalPollSelection = false;
      }

      var query = "?blogId=" + blogId + "&context=" + context;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );


      that.socket.on('init-settings', function (msg) {
        getLibObject("helper").log("init-settings");
        getLibObject("helper").log(msg);
      });

      that.socket.on('poll-current-change', function (msg) {
        getLibObject("helper").log("poll-current-change");
        getLibObject("helper").log(msg);

        if(
          (useGlobalPollSelection && !msg.data.post_id) ||
          (!useGlobalPollSelection && msg.data.post_id && parseInt(postId) === parseInt(msg.data.post_id))
        ) {
          getLibObject("poll").changeCurrentPoll(msg.data);
        }
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      getLibObject("helper").log("init websocket error:");
      getLibObject("helper").log(e);
    }
    return false;
  };

  that.initBackendComments = function (options) {
    var libHelper = getLibObject("helper");

    try {
      getLibObject("helper").log("init websocket");

      // if no session is selected template will change to selected poll from poll options
      // if session is selected page will stick to
      var context = "edit_comments";
      var blogId = that.getGlobalBlogId();

      var query = "?blogId=" + blogId + "&context=" + context;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );


      that.socket.on('init-settings', function (msg) {
        getLibObject("helper").log("init-settings");
        getLibObject("helper").log(msg);
      });

      that.socket.on('enable-commentedit', function (msg) {
        getLibObject("helper").log("disable-commentedit");
        getLibObject("helper").log(msg);

        getLibObject("backend_comments").enableComment(msg.data);
      });

      that.socket.on('disable-commentedit', function (msg) {
        getLibObject("helper").log("disable-commentedit");
        getLibObject("helper").log(msg);

        getLibObject("backend_comments").disableComment(msg.data);
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      getLibObject("helper").log("init websocket error:");
      getLibObject("helper").log(e);
    }
    return false;
  };

  that.initSingleBackendComment = function (options) {
    var libHelper = getLibObject("helper");

    try {
      getLibObject("helper").log("init websocket");

      // if no session is selected template will change to selected poll from poll options
      // if session is selected page will stick to
      var context = "edit_single_comment";
      var blogId = that.getGlobalBlogId();
      var commentId = $('[name=comment_ID]').val();

      var query = "?blogId=" + blogId + "&context=" + context + "&commentId=" + commentId;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );


      that.socket.on('init-settings', function (msg) {
        getLibObject("helper").log("init-settings");
        getLibObject("helper").log(msg);
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      getLibObject("helper").log("init websocket error:");
      getLibObject("helper").log(e);
    }
    return false;
  };

  that.initFrontpage = function (options) {
    var libHelper = getLibObject("helper");
    var libFrontpage = getLibObject("frontpage");

    try {
      getLibObject("helper").log("init websocket");

      // if no session is selected template will change to selected poll from poll options
      // if session is selected page will stick to
      var context = "frontpage";
      var blogId = that.getGlobalBlogId();

      var query = "?blogId=" + blogId + "&context=" + context;

      that.socket = io.connect(
        that.getConnectHost(options) + query,
        that.getConnectOptions()
      );

      that.socket.on('init-settings', function (msg) {
        getLibObject("helper").log("init-settings");
        getLibObject("helper").log(msg);
      });

      that.socket.on('unlock-sessions', function(msg) {
        libFrontpage.unlockSessions(msg.sessions);
      });

      that.socket.on('init-save-session', function (msg) {
        getLibObject("helper").log("init-save-session");
        getLibObject("helper").log(msg);

        getLibObject("savethedate").initSaveASession(msg.data);
      });

      that.socket.on('growl-error', function (msg) {
        that.growlError(msg);
      });

      that.socket.on('growl-notice', function(msg) {
        that.growlNotice(msg);
      });

      return true;
    } catch(e) {
      getLibObject("helper").log("init websocket error:");
      getLibObject("helper").log(e);
    }
    return false;
  };

  that.growlNotice = function (msg) {
    getLibObject("helper").log("growl-notice");
    getLibObject("helper").log(msg);

    getLibObject("helper").growlnotice({message: msg.message});
  };

  that.growlError = function (msg) {
    getLibObject("helper").log("growl-error");
    getLibObject("helper").log(msg);

    getLibObject("helper").growlerror({message: msg.message});
  };

  window.vrnetworld.websocket = that;
})(jQuery);
